import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ResellerRouteProps {
  children: React.ReactNode;
}

const ResellerRoute: React.FC<ResellerRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.company?.company_type !== 'reseller') {
    return <Navigate to="/dashboard" replace />;
  }

  if (user.company?.reseller_status !== 'approved') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full mx-auto p-8 bg-white rounded-lg shadow text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-3">Reseller Account Pending</h2>
          <p className="text-gray-600">
            Your reseller account is pending approval. You will be notified once your account has
            been reviewed. Please contact support if you have questions.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ResellerRoute;
